import appConfig from 'app-config';
import _ from 'lodash';

const QA_PRECHAT_URL = 'https://farmerssrm--soqa.sandbox.my.salesforce-sites.com/apex/SRM_LaunchAskSOPage?';
const UAT_PRECHAT_URL = 'https://sofa-uat-farmers--souat1.sandbox.my.salesforce-sites.com/apex/SRM_LaunchAskSOPage?';
const PROD_PRECHAT_URL = 'https://farmerssrm.my.salesforce-sites.com/apex/SRM_LaunchAskSOPage?';
const BRAND_NAME_PARAM = 'FWS';
const SOURCE_SYSTEM_PARAM = 'A360';
const BILLING_LOB_PATH = { 'Billing': '/billing'};
const POLICY_LOB_PATH = { 'Policy': '/policies'};
const ACCOUNT_LOB_PATH = { 'Account': '/accounts'};

const LOB_MAPPINGS = {
    '/quote-pa': 'Auto',
    '/quote-ho': 'Home',
    '/quote-pup': 'Umbrella',
    '/endorsement-pa': 'Auto',
    '/endorsement-ho': 'Home',
    '/endorsement-pup': 'Umbrella',
    '/billing': 'Billing',
    '/accounts': '',
    '/policies': '',
    'PersonalAuto': 'Auto',
    'HOPHomeowners': 'Home',
    'PersonalUmbrella': 'Umbrella'
}
let pageData = false;

function AskServiceOpsService() {

    const getBaseUrlFromEnvironment = () => {
        let url = '';
        const hostname = window.location.hostname.split(".")[0];
        const hostnameSplit = hostname.split("-");
        const environment = hostnameSplit[hostnameSplit.length - 1];

        if (environment.indexOf('prod') > -1) {
            url = PROD_PRECHAT_URL
        } else if (environment.indexOf('uat') > -1) {
            url = UAT_PRECHAT_URL
        } else {
            url = QA_PRECHAT_URL
        }

        return url;
    };

    const filterLobPaths = (location, paths) => {
        const lobPaths = Object.values(paths) || [];
        const currentLOB = lobPaths.filter((value) => location.indexOf(value) !== -1);
        
        return _.isEmpty(currentLOB) ? '' : currentLOB;
    }

    const isOnAccountSummary = (history) => {
        const fromLocation = history.location.pathname;
        return !_.isEmpty(pageData.accountNumber) && fromLocation.indexOf(pageData.accountNumber) > -1
    }

    const isOnPolicySummary = (history) => {
        const fromLocation = history.location.pathname;
        return !_.isEmpty(pageData.policyNumber) && fromLocation.indexOf(pageData.policyNumber) > -1
    }

    const mapFilteredLobPath = (path) => {
        if (_.isEmpty(path) || path === '') {
            return '';
        } 
        if (!_.isEmpty(path) && (path[0] === '/policies') && !_.isEmpty(pageData.policyProductCode)) {
            return LOB_MAPPINGS[pageData.policyProductCode]
        }

        return LOB_MAPPINGS[path[0]];
    };

    const getCurrentLOB = (history) => {
        const { lobQuoteURL, lobEndorsementURL } = appConfig;
        const fromLocation = history.location.pathname;
        let lobType = '';
        
        let filteredLobPath = filterLobPaths(fromLocation, lobQuoteURL);
        lobType = filteredLobPath ? 'submission' : '';
        if (_.isEmpty(filteredLobPath)) {
            filteredLobPath = filterLobPaths(fromLocation, lobEndorsementURL);
            lobType = filteredLobPath ? 'endorsement' : '';
        }
        if (_.isEmpty(filteredLobPath)) {
            filteredLobPath = filterLobPaths(fromLocation, BILLING_LOB_PATH);
            lobType = filteredLobPath ? 'billing' : '';
        }
        if (_.isEmpty(filteredLobPath)) {
            filteredLobPath = filterLobPaths(fromLocation, POLICY_LOB_PATH);
            lobType = filteredLobPath ? 'policy' : '';
        }
        if (_.isEmpty(filteredLobPath)) {
            filteredLobPath = filterLobPaths(fromLocation, ACCOUNT_LOB_PATH);
            lobType = filteredLobPath ? 'account' : '';
        }

        const mappedLobPath = mapFilteredLobPath(filteredLobPath);


        return {lobType, mappedLobPath};
    };

    const getCurrentStateCode = (history, lobType) => {
        let stateCode = '';

        if (lobType === 'submission') {
            stateCode = history.location.state.submission.baseData.accountHolder.primaryAddress.state
        }
        else if ((lobType === 'endorsement') || (lobType === 'billing') || (lobType === 'account' && isOnAccountSummary(history)) || (lobType === 'policy' && isOnPolicySummary(history))) {
            stateCode = pageData.state;
        }

        return stateCode
    };

    const getUrlParameters = (history) => {
        const params = new URLSearchParams;
        const {lobType, mappedLobPath} = getCurrentLOB(history);
        const stateCode = getCurrentStateCode(history, lobType);

        params.append('brandName', BRAND_NAME_PARAM);
        params.append('LOBName', mappedLobPath);
        params.append('stateCode', stateCode);
        params.append('sourceSystem', SOURCE_SYSTEM_PARAM);

        return params.toString();
    };

    const getPreChatLink = (history) => {
        const preChatUrl = getBaseUrlFromEnvironment();
        const urlParameters = getUrlParameters(history);
        return preChatUrl + urlParameters;
    };

    const storeCurrentPageData = (state, policyNumber, productCode, accountNumber) => {
        pageData = {
            'state': state,
            'policyNumber': policyNumber,
            'policyProductCode': productCode,
            'accountNumber': accountNumber
        }
    };

    return {
        getPreChatLink,
        storeCurrentPageData
    };
}


export default AskServiceOpsService;
